import Roles from '@/auth/roles';
import ManagerForm from './manager-form';
import ManagerList from './manager-list';
import ManagerHistoryFull from './manager-history/manager-history-full/manager-history-full';
import ManagerHistorySingle from './manager-history/manager-history-single/manager-history-single';
import ManagerShow from './manager-show';

const roles = Roles.values;

export default [
  {
    name: 'managerList',
    path: 'manager',
    component: ManagerList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.managerViewer.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'managerNew',
    path: 'manager/new',
    component: ManagerForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'managerEdit',
    path: 'manager/:id/edit',
    component: ManagerForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.managerEditor.id
      ]
    }
  },
  {
    name: 'managerHistorySingle',
    path: 'manager/:id/history',
    component: ManagerHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'managerHistoryFull',
    path: 'manager/history',
    component: ManagerHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'managerShow',
    path: 'manager/:id',
    component: ManagerShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.managerViewer.id,
        roles.managerEditor.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/manager/manager-routes.js